import React, { useEffect, useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import { useLocation, useParams } from 'react-router-dom';

import GroupCheckFilter from './GroupCheckFilter';
import {
  ALL_KEYS_POSITION,
  ALL_KEYS_POSITION_BALL_METRICS_TAB,
  BALL,
  DEFENSE_KEYS_POSITION,
  EMPTY_ARRAY,
  FILTER_KEYS,
  FLIGHTS,
  OFFENSE_KEYS_POSITION,
  POSITIONS,
  SPEC_KEYS_POSITION
} from '../../../../config/constants';
import { isIn, routeToSpecificScope, text_truncate } from '../../../../helpers';
import { useFiltersDispatch, useFiltersState } from '../../../../store/hooks';
import {
  PositionFilterItem,
  PositionFilterParamsType,
  PositionFilterWrappedParamsType,
  PositionsGroupType
} from './types';
import { ParamWrapper } from '../ParamWrapper';

const PositionFilterWrapped = ({
                                 changeFilterDataWrapped,
                                 forceScope,
                                 show,
                                 close,
                                 open,
                                 onApply
                               }: PositionFilterWrappedParamsType) => {
  const { pathname } = useLocation();
  const { changeFilterData } = useFiltersDispatch();
  const { tab, subTab } = useParams<{ tab: string, subTab: string }>();
  const specificScope = forceScope || routeToSpecificScope(pathname);
  const scope = specificScope;
  const isBallMetricsTab = tab === BALL && subTab === FLIGHTS;
  const { [FILTER_KEYS.POSITIONS]: filterData = EMPTY_ARRAY } = useFiltersState(specificScope, FILTER_KEYS.POSITIONS);
  const isLacrossePossitionState = filterData.find(filter => filter.name === "ATTACK"||filter.name ==="DEFENSE"||
  filter.name ==="FO"||filter.name ==="GOALIE"||filter.name ==="LSM"||filter.name ==="MIDFIELD");
  if(isLacrossePossitionState){
    changeFilterData([], FILTER_KEYS.POSITIONS)();
  }
  const OFFENSE=['QB', 'RB','WR','TE','OL'];
  const DEFENSE=['DL', 'LB','DB'];
  const SPEC=['SPEC'];
  const [allSelected, setAllSelected] = useState(filterData.length === 0);
  const [defSelected, setDefSelected] = useState(filterData.length === 0);
  const [offSelected, setOffSelected] = useState(filterData.length === 0);
  const [specSelected, setSpecSelected] = useState(filterData.length === 0);
  const [newPositionsSelected, 
    setNewPositionsSelected] = useState<PositionFilterItem[]>(filterData.length === 0 ?
    ALL_KEYS_POSITION.map(position => ({ name: position, value: position })) :
    filterData);
  const [appliqued, setAppliqued] = useState(false);
  const [groupsContent, setGroupsContent] = useState<string[]>(isBallMetricsTab? SPEC.concat('QB') : OFFENSE.concat(DEFENSE,SPEC));
  

  useEffect(() => {
      const filteredPositions:string[] =[];
    
      newPositionsSelected.forEach(value=>{
        return filteredPositions.push(value.value);
      });

      const allOffense = OFFENSE_KEYS_POSITION.every(item => {
        return filteredPositions.indexOf(item) !== -1;
      });
      const allDefense = DEFENSE_KEYS_POSITION.every(item => {
        return filteredPositions.indexOf(item) !== -1;
      });
      const allSpec = SPEC_KEYS_POSITION.every(item => {
        return filteredPositions.indexOf(item) !== -1;
      });
  
      setOffSelected(allOffense);
      setDefSelected(allDefense);
      setSpecSelected(allSpec);
  }, [groupsContent, allSelected]);
  
  const updatePositionSelectedState = (newCopyPositionsSelected: PositionFilterItem[]) => {
    setNewPositionsSelected([...newCopyPositionsSelected]);
    setAllSelected(newCopyPositionsSelected.length === (isBallMetricsTab ? ALL_KEYS_POSITION_BALL_METRICS_TAB : ALL_KEYS_POSITION).length);
  };
  
  const addPosition = (args: PositionFilterItem[], flag?:string) => {
    let newCopyPositionsSelected = [...newPositionsSelected];
    args.forEach((position) => {
      if (isIn(newCopyPositionsSelected, position)) {
        newCopyPositionsSelected = newCopyPositionsSelected.filter(pos => (pos.value !== position.value));
      } else {
        newCopyPositionsSelected.push(position);
      }
    });
    if(flag){
      addGroup([flag]);
    }
   
    updatePositionSelectedState(newCopyPositionsSelected);
  };
  const addGroup = (args: string[]) => {
    let newCopygroupsContent = [...groupsContent];
    args.forEach((value) => {
      if (isIn(newCopygroupsContent, value)) {
        newCopygroupsContent = newCopygroupsContent.filter(pos => (pos !== value));
      } else {
        newCopygroupsContent.push(value);
      }
    }); 
    setGroupsContent(newCopygroupsContent);
  };
 
  const groups: JSX.Element[] = [];
  POSITIONS.forEach((group, index) => {
    if ((isBallMetricsTab && (group.groupLabel === 'QB' || group.groupLabel === 'SPEC')) || !isBallMetricsTab) {
      groups.push(
        <GroupCheckFilter
          optionsSelected={newPositionsSelected.filter((position) => {
            let isIn = false;
            group.options.forEach((option) => {
              if (option.key === position.value) {
                isIn = true;
              }
            });
            return isIn;
          })}
          allSelected={group.options.every((option => (isIn(newPositionsSelected, {
            name: option.key,
            value: option.key
          }))))}
          groupLabel={group.groupLabel}
          options={group.options}
          key={index + group.groupLabel}
          addPosition={addPosition}
          tab={scope ? scope : ''}
        />
      );
    }
  });
  const nameOfKey = (group: PositionsGroupType) => {
    let name = '';
    group.options.forEach((option) => {
      if (option.key === filterData[0].value) {
        // name = text_truncate(option.label, positionsSelected.length === 1 ? 13 : 8, '...');
        name = option.label;
      }
    });
    return name;
  };
  const onOpen = () => {
    updatePositionSelectedState(filterData.length === 0 ?
      (isBallMetricsTab ? ALL_KEYS_POSITION_BALL_METRICS_TAB : ALL_KEYS_POSITION).map(position => ({
        name: position,
        value: position
      })) :
      filterData);
    open();
  };
  const allOffense = OFFENSE_KEYS_POSITION.map(option => ({ name: option, value: option }));
  const allDefense = DEFENSE_KEYS_POSITION.map(option => ({ name: option, value: option }));
  const allSpec = SPEC_KEYS_POSITION.map(option => ({ name: option, value: option }));
  return (
    <Dropdown className="dropdown-position-filter filter-f1" show={show} onToggle={show ? close : onOpen}>
      <Dropdown.Toggle id="dropdown-basic-position-filter" className="btn-border" style={forceScope?.includes('PRACTICE_TRACKING')? {width: '150px'}:{}}>
        <label className={appliqued ? 'appliqued' : ''}>POSITION</label>
        {(isBallMetricsTab ? ALL_KEYS_POSITION_BALL_METRICS_TAB : ALL_KEYS_POSITION).every((key => (isIn(filterData, {
          name: key,
          value: key
        })))) || filterData.length === 0 ?
          'All Positions' :
          filterData.length === 1 ?
            text_truncate(POSITIONS.reduce((result, group) => (result + nameOfKey(group)), ''), 15) :
            filterData.length === 2 ?
            text_truncate(POSITIONS.reduce((result, group) => (result + nameOfKey(group)), '') , 10)+ ' (+1)' :
              'Multiple (' + filterData.length + ')'}
      </Dropdown.Toggle>
      <Dropdown.Menu>
        <div className="p-h-01">
          Select All
          <div className="p-i-01">
            <input
              type="checkbox" id={scope + '-all-selected'} name="set-name" className="switch-input"
              checked={allSelected}
              onChange={() => {
                if (allSelected) {
                  updatePositionSelectedState([]);
                  setGroupsContent(['']);
                } else {
                  updatePositionSelectedState((isBallMetricsTab ? ALL_KEYS_POSITION_BALL_METRICS_TAB : ALL_KEYS_POSITION).map(position => ({
                    name: position,
                    value: position
                  })));

                  if(!isBallMetricsTab)setGroupsContent(OFFENSE.concat(DEFENSE,SPEC));
                  
                }
              }}
            />
            <label htmlFor={scope + '-all-selected'} id={scope + '-all-selected-label'} className="switch-label" />
          </div>
          </div>
          {
            !isBallMetricsTab &&(
          <div className="p-h-01-group">
            OFF
          <div className="p-i-01-group" >
            <input
              type="checkbox" id={scope + '-off-selected'} name="off-name" className="switch-input"
              checked={offSelected}
              onChange={() => {
                if (offSelected) {
                  addPosition(allOffense.filter((position) => (isIn(newPositionsSelected, position))));
                  addGroup(OFFENSE.filter((value)=>(isIn(groupsContent,value))));
                } else {
                  let newCopygroupsContent = [...groupsContent];
                  const newPositions = [...newPositionsSelected];
                  OFFENSE.forEach((value) => {
                    if (isIn(newCopygroupsContent, value)) {
                      newCopygroupsContent = newCopygroupsContent.filter(pos => (pos !== value));
                    } else {
                      newCopygroupsContent.push(value);
                    }
                  }); 
                  DEFENSE.forEach((value) => {
                    if (isIn(newCopygroupsContent, value)) {
                      newCopygroupsContent = newCopygroupsContent.filter(pos => (pos !== value));
                    }
                  }); 
                  SPEC.forEach((value) => {
                    if (isIn(newCopygroupsContent, value)) {
                      newCopygroupsContent = newCopygroupsContent.filter(pos => (pos !== value));
                    }
                  });
                  addPosition(allOffense.filter((position) => (!isIn(newPositions, position))));
                  addGroup(newCopygroupsContent);
                }
              }}
            />
            <label htmlFor={scope + '-off-selected'} id={scope + '-off-selected-label'} className="switch-label" />
          </div>
       
        <div style={{marginLeft:'56px'}}>
          DEF
          <div className="p-i-01-group" style={{marginLeft:'70px'}}>
            <input
              type="checkbox" id={scope + '-def-selected'} name="set-name" className="switch-input"
              checked={defSelected}
              onChange={() => {
                if (defSelected) {
                  addPosition(allDefense.filter((position) => (isIn(newPositionsSelected, position))));
                  addGroup(DEFENSE.filter((value)=>(isIn(groupsContent,value))));
                } else {
                  let newCopygroupsContent = [...groupsContent];
                  const newPositions = [...newPositionsSelected];
                  const allDefenseCopy = [...allDefense];
                  DEFENSE.forEach((value) => {
                    if (isIn(newCopygroupsContent, value)) {
                      newCopygroupsContent = newCopygroupsContent.filter(pos => (pos !== value));
                    } else {
                      newCopygroupsContent.push(value);
                    }
                  }); 
                  OFFENSE.forEach((value) => {
                    if (isIn(newCopygroupsContent, value)) {
                      newCopygroupsContent = newCopygroupsContent.filter(pos => (pos !== value));
                    }
                  }); 
                  SPEC.forEach((value) => {
                    if (isIn(newCopygroupsContent, value)) {
                      newCopygroupsContent = newCopygroupsContent.filter(pos => (pos !== value));
                    }
                  });
                  addPosition(allDefenseCopy.filter((position) => (!isIn(newPositions, position))));
                  addGroup(newCopygroupsContent);
                }
              }}
            />
            <label htmlFor={scope + '-def-selected'} id={scope + '-def-selected-label'} className="switch-label" />
          </div>
          </div>
          <div style={{marginLeft:'50px'}}>
          SPEC
          <div className="p-i-01-group" style={{marginLeft:'150px'}}>
            <input
              type="checkbox" id={scope + '-spec-selected'} name="set-name" className="switch-input"
              checked={specSelected}
              onChange={() => {
                if (specSelected) {
                  addPosition(allSpec.filter((position) => (isIn(newPositionsSelected, position))));
                  addGroup(SPEC.filter((value)=>(isIn(groupsContent,value))));
                } else {
                  const newPositions = [...newPositionsSelected];
                  const allSpecCopy = [...allSpec];
                  addGroup(SPEC);
                  addPosition(allSpecCopy.filter((position) => (!isIn(newPositions, position))));
                }
              }}
            />
            <label htmlFor={scope + '-spec-selected'} id={scope + '-spec-selected-label'} className="switch-label" />
          </div>
          </div>
          </div>
            )
          }
          
        <div className="p-b-01" style={isBallMetricsTab ? { height: 234 } : {}}>
          {groups}
        </div>
        <div className="footer-s">
          <button className="btn-transparet" onClick={close}>Cancel</button>
          <button
            className={'btn-blue ' + (newPositionsSelected.length === 0 ? 'opacity-50' : '')}
            onClick={() => {
              close();
              changeFilterDataWrapped(ALL_KEYS_POSITION.every((key => (isIn(newPositionsSelected, {
                name: key,
                value: key
              })))) ? [] : newPositionsSelected,)();
              if (onApply) {
                onApply();
              }
              setAppliqued(true);
            }}
            disabled={newPositionsSelected.length === 0}
          >
            Apply
          </button>
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
};

const PositionFilter = (props: PositionFilterParamsType) => {
  return (
    <ParamWrapper
      fromUrlSearchParam={() => []}
      toUrlSearchParam={() => ''}
      Component={PositionFilterWrapped}
      props={props}
      filterKey={FILTER_KEYS.POSITIONS}
    />
  );
};

export default PositionFilter;
export * from './types';